import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';

import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from 'util/CustomScrollbars';

import {connect} from 'react-redux';

class SidenavContent extends Component {
  componentDidMount() {
    const {history} = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`;// get current path

    const menuLi = document.getElementsByClassName('menu');
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, 'li');
          if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
            menuLi[j].classList.remove('open')
          }
        }
        this.classList.toggle('open');
      }
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  componentWillReceiveProps(nextProps) {

    const {history} = nextProps;
    const pathname = `${history.location.pathname}`;// get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
        if (typeof document.body[fn] == 'function') {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {

    }

    return null;
  }

  isRoleCheck = (roles,roleId)=>{
    return roles.find(x=> x.id===roleId) !== undefined
  }

  render() {
    const userRoles = this.props.authUser !== null ? this.props.authUser.userRoles : [];

    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">

          <li className="nav-header">
          <IntlMessages id="sidebar.main"/> 
          </li>
          <li className="menu no-arrow">
            <NavLink to="/bys/mainPage">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.mainPage"/></span>
            </NavLink>
          </li>
          {
        (this.isRoleCheck(userRoles,91) ||    this.isRoleCheck(userRoles,1) )&& 
          <li className="menu no-arrow">
            <NavLink to="/bys/addActivityPage">
              <i className="zmdi zmdi-plus zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="mainPage.button.newActivity"/></span>
            </NavLink>
          </li>
          }
          <li className="menu no-arrow">
            <NavLink to="/bys/listActivityPage">
              <i className="zmdi zmdi-format-list-numbered zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="mainPage.button.listActivity"/></span>
            </NavLink>
          </li>


          <li className="nav-header">
          <IntlMessages id="sidebar.secretariat"/> 
          </li>
          <li className="menu no-arrow">
            <NavLink to="/bys/managementActivityPage">
              <i className="zmdi zmdi-globe zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="mainPage.button.myEvent"/></span>
            </NavLink>
          </li>

          <li className="nav-header">
          <IntlMessages id="sidebar.submissions"/> 
          </li>
          <li className="menu no-arrow">
            <NavLink to="/bys/mySubmissionPage">
              <i className="zmdi zmdi-star zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.mySubmissions"/></span>
            </NavLink>
          </li>

          <li className="nav-header">
          <IntlMessages id="sidebar.referee"/> 
          </li>
          <li className="menu no-arrow">
            <NavLink to="/bys/myRefereePage">
              <i className="zmdi zmdi-rss zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.myReferee"/></span>
            </NavLink>
          </li>
          {/* <li className="menu no-arrow">
            <NavLink to="/bys/myRefereePastPage">
              <i className="zmdi zmdi-rss zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.myRefereePast"/></span>
            </NavLink>
          </li> */}
        </ul>
      </CustomScrollbars>
    );
  }
}

//export default withRouter(SidenavContent);

const mapStateToProps = ({auth,settings}) => {
  const {authUser} = auth;
  const {locale} = settings;
  return {authUser,locale};
};

export default withRouter(connect(mapStateToProps)(SidenavContent));


